import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-skeleton-footer',
  templateUrl: './skeleton-footer.component.html',
  styleUrls: ['./skeleton-footer.component.scss']
})
export class SkeletonFooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
